export default __webpack_public_path__ + "static/media/logo2.61d31e3c.png";